import http from '../../utils/services/http';
import { GetLabelsRequestParams } from '../../../common/api/labels/labelRouteTypes';
import { LabeledElementsData } from '../../../common/api/labels/labelElementsRetrievalRouteTypes';
import { Label } from '../../../common/labels/labelTypes';

export const fetchLabelsFromDb = async (params: GetLabelsRequestParams = {}): Promise<Label[]> => {
    const response = await http({
        method: 'get',
        url: `labels`,
        params,
    });

    return response.data.labels;
};

export const getLabelUsageData = async (
    labelId: string,
): Promise<{
    labeledElements: LabeledElementsData[];
}> => {
    const response = await http({
        method: 'get',
        url: `labels/${labelId}/usage`,
    });

    return response.data;
};
